import VColumnAdmin from './index.vue';

export default {
  install: (Vue) => Vue.component('VColumnAdmin', VColumnAdmin),
};
